export const BASE_PATH = process.env.VUE_APP_BASE_PATH;
export const SHOP_BASE_PATH = process.env.VUE_APP_SHOP_BASE_PATH;
export const PAYMENT_LINK_URL = process.env.VUE_APP_PAYMENT_LINK_URL;
export const STAR_CARD_REGISTER = 'https://card.paystar.ir/card-register';

// Previous Url
// export const SHOP_LOGIN = 'https://shop.paystar.ir'

// New Url
export const SHOP_LOGIN = 'https://paystar.shop';
export const SHOP_ADDRESS = 'https://paystar.shop/@';
export const MAIN_ADDRESS = 'https://paystar.ir/@';
export const PEGEN_LOGIN = 'https://pegen.ir';
export const SEPEHR_LOGIN = 'https://sepehr.store';
export const SEPEHR_ADDRESS = 'https://sepehr.store/@';
export const PEGEN_ADDRESS = 'https://pegen.ir/@';

// identify refrence (when redirect from pegen or marketplace to mypanel)
export const SHOP_REFRENCE = 'https://paystar.shop/';
export const SEPEHR_REFRENCE = 'https://sepehr.store/';
export const LOGIN_REFRENCE = 'https://my.paystar.ir/login';
export const VERIFY_REFRENCE = 'https://my.paystar.ir/verify';
export const PEGEN_REFRENCE = 'https://pegen.ir/';
export const MYPANEL_REFRENCE = 'https://my.paystar.ir/';
